module.exports = __webpack_public_path__ + "static/media/eye-opened.d69e11a6.svg";